import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileInvoice,
  faUserPlus,
  faUserEdit,
  faUserCog,
  faChartBar,
  faListCheck,
  faSignOutAlt,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../../contexts/auth.context";
import { useContext } from "react";
import styles from "./HamburgerMenu.module.css";

function HamburgerMenu({ isOpen, onClose }) {
  const navigate = useNavigate();
  const { logout, isAdmin, isTreasurer } = useContext(AuthContext);

  const menuItems = [
    {
      label: "Nueva Factura",
      icon: faFileInvoice,
      onClick: () => {
        navigate("/newbill");
        onClose();
      },
    },
    {
      label: "Control de asistencia",
      icon: faListCheck,
      onClick: () => {
        navigate("/sections");
        onClose();
      },
      roles: ["all"],
    },
    {
      label: "Editar socios",
      icon: faUserEdit,
      onClick: () => {
        navigate("/sections?edit=true");
        onClose();
      },
    },
    {
      label: "Nuevo socio",
      icon: faUserPlus,
      onClick: () => {
        navigate("/editLearner/new");
        onClose();
      },
    },
    {
      label: "Patrullometro",
      icon: faChartBar,
      onClick: () => {
        navigate("/patrolmeter");
        onClose();
      },
    },
    {
      label: "Editar Patrullometro",
      icon: faUserCog,
      onClick: () => {
        navigate("/patrolmeterEdit");
        onClose();
      },
    },
    {
      label: "Facturas",
      icon: faFileInvoice,
      onClick: () => {
        navigate("/listbills");
        onClose();
      },
      roles: ["ADMIN", "TESORERA"],
    },
    {
      label: "Crear usuario",
      icon: faUserPlus,
      onClick: () => {
        navigate("/newUserForm");
        onClose();
      },
      roles: ["ADMIN"],
    },
    {
      label: "Salir",
      icon: faSignOutAlt,
      onClick: () => {
        logout();
        onClose();
      },
      isLogout: true,
    },
  ];

  const hasPermission = (item) => {
    if (!item.roles) return true;
    if (item.roles.includes("all")) return true;

    if (item.roles.includes("ADMIN") && isAdmin) return true;
    if (item.roles.includes("TESORERA") && isTreasurer) return true;

    return false;
  };

  return (
    <>
      {isOpen && <div className={styles["hamburger-overlay"]} onClick={onClose} />}
      <div className={`${styles["hamburger-menu"]} ${isOpen ? styles.open : ""}`}>
        <div className={styles["hamburger-header"]}>
          <button className={styles["hamburger-close"]} onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <nav className={styles["hamburger-nav"]}>
          {menuItems
            .filter((item) => hasPermission(item))
            .map((item, index) => (
              <button
                key={index}
                className={`${styles["hamburger-item"]} ${item.isLogout ? styles.logout : ""}`}
                onClick={item.onClick}
              >
                <FontAwesomeIcon icon={item.icon} className={styles["hamburger-icon"]} />
                <span>{item.label}</span>
              </button>
            ))}
        </nav>
      </div>
    </>
  );
}

export default HamburgerMenu;
